import { render, staticRenderFns } from "./AdminVotesPage.vue?vue&type=template&id=659d1be4&scoped=true&"
import script from "./AdminVotesPage.vue?vue&type=script&lang=js&"
export * from "./AdminVotesPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminVotesPage.vue?vue&type=style&index=0&id=659d1be4&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d1be4",
  null
  
)

export default component.exports